import React, { Fragment, useState, useContext, useEffect } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import FilterTable from "../../Common/Component/FilterTable";
import SearchTable from "../../Common/Component/SearchTable";
import {
  InventoryFilterColumns,
  searchColumns,
} from "../../../Data/Driver/CarInventoryListing";
import SharedDataContext from "../../../_helper/SharedData";
import { showAlert } from "../../../Services/Shared.service";
import SelectedFilter from "./SelectedFilter";
import {
  getDriverInventoryListCount,
  getDriverInventoryList,
  getDriverTableFilterData,
  getDriverTableSearchData,
  getInventoryTableFilterData,
  getInventoryTableSearchData,
} from "../../../Services/Driver.service";
import { useLocation } from "react-router";
import CarListTable from "./CarListTable";

const CarListing = () => {
  const location = useLocation();
  const { globalCityField, setShowApiLoader, setPageNumber } =
    useContext(SharedDataContext);

  const [inventoryData, setInventoryData] = useState([]);

  const [paginationTotalRows, setPaginationTotalRows] = useState(0);

  const [pagination, setPagination] = useState(
    location.state?.pageNumber ? location.state.pageNumber : 0
  );
  const [rowsPerPage, setRowsPerPage] = useState(20);

  const [filterData, setFilterData] = useState(location.state?.filterdata?.length > 0 ? location.state?.filterdata : []);

  const [searchData, setSearchData] = useState(location.state?.searchdata ? location.state?.searchdata : "");
  const [loader, setLoader] = useState(false);
  const [filterType, setFilterType] = useState(location.state?.filterdata?.length > 0 ? "filter" : location.state?.searchdata ? "search" : "");

  const cabStatusData = [
    { label: "AirportZone", value: "AirportZone" },
    { label: "Assigned", value: "Assigned" },
    { label: "Blocked", value: "Blocked" },
    { label: "InActive", value: "InActive" },
    { label: "LogIn", value: "LogIn" },
    { label: "Logout", value: "Logout" },
    { label: "OffLine", value: "OffLine" },
    { label: "OnLine", value: "OnLine" },
    { label: "OnTrip", value: "OnTrip" },
  ]

  let columns = [];
  InventoryFilterColumns.map((element) => {
    if (element.value) {
      columns.push({
        value: {
          name: element.name,
          value: element.value,
          type: element.type,
        },
        label: element.name,
      });
    }
  });

  const disableLoaders = () => {
    setLoader(false);
    // setShowApiLoader(false);
  };

  const removeFilter = (index) => {
    const newfilterData = [...filterData];
    newfilterData.splice(index, 1);
    setFilterData(newfilterData);
  };
  const fetchCarData = async ({isSearchFilterPage}) => {
    const serviceCityId = globalCityField.value?.id || 0;
    const filterCityId = globalCityField.value?.id?.toString() || null;
    const obj = {
      page: pagination,
      size: rowsPerPage,
      serviceCityId: serviceCityId,
    };
    console.log(filterData, searchData, filterType, "filterType");
    if (filterData.length == 0 && !searchData) {
      setLoader(true);
      getDriverInventoryList(obj)
        .then((result) => {
          const data = result.data?.list || [];
          setInventoryData(data);
          setPaginationTotalRows(result.data.count);
          disableLoaders();
        })
        .catch((err) => {
          disableLoaders();
          setInventoryData([]);
          showAlert("error", "Something went wrong");
        });
      // getDriverInventoryListCount(obj).then((result) => {
      //   if (result.data) {
      //     setPaginationTotalRows(result.data);
      //   }
      // });
    } else if (filterData.length > 0 && filterType == "filter") {
      let body = {       
          serviceCityId: filterCityId,
          driverName : null,
          driverMobile: null,
          status : null,
          carNo : null,
          lastDutyOn : null,
          lastUpdatedOn : null,
      
      }
      filterData.forEach((element) => {
      
        body[element.column_name] = element.values[0]
  
    });
      setLoader(true);
      getInventoryTableFilterData({ ...obj, page:  isSearchFilterPage }, body)
        .then((result) => {
          if (result.data) {
            const data = result.data?.filterResponse || [];
            setInventoryData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setInventoryData([]);
          showAlert("error", "Something went wrong");
        });
    } else if (searchData && filterType == "search") {
      let body = [
        // {
        //   type: "Driver",
        // },
        {
          service_city: filterCityId,
        },
        {
          column_names: searchColumns,
          value: searchData,
        },
      ];
      setLoader(true);
      getInventoryTableSearchData(
        { ...obj, page:  isSearchFilterPage },
        body
      )
        .then((result) => {
          if (result.data) {
            const data = result.data?.searchResponse || [];
            setInventoryData(data);
            setPaginationTotalRows(result.data.count);
            disableLoaders();
          }
        })
        .catch((err) => {
          disableLoaders();
          setInventoryData([]);
          showAlert("error", "Something went wrong");
        });
    }
  };

  const onChangePage = (page) => {
    setPagination(page - 1);
  };

  const onChangeRowsPerPage = (currentRowsPerPage) => {
    setRowsPerPage(currentRowsPerPage);
  };

  useEffect(() => {
    if (filterData.length == 0 && filterType != "filter") return;
    fetchCarData({isSearchFilterPage: 0});
  }, [filterData]);

  useEffect(() => {
    if (!searchData && filterType != "search") return;
    fetchCarData({isSearchFilterPage: 0});
  }, [searchData]);

  useEffect(() => {
    fetchCarData({isSearchFilterPage: pagination});
  }, [pagination, rowsPerPage, globalCityField.value]);
  return (
    <Fragment>
      <Breadcrumbs
        parent="Inventory"
        subParent="Inventory Listing"
        mainTitle="Inventory Listing"
        span1={
          <FilterTable
            options={columns}
            setFilterData={setFilterData}
            filterData={filterData}
            statusData={cabStatusData}
            setSearchData={setSearchData}
            setFilterType={setFilterType}
          />
        }
        span3={
          <SearchTable
            setFilterType={setFilterType}
            searchData={searchData}
            setSearchData={setSearchData}
            setFilterData={setFilterData}
          />
        }
      />
      <Container fluid={true} className="datatables">
        <Row className="selected-filter">
          {filterData.map((element, i) => {
            return (
              <SelectedFilter
                key={i}
                element={element}
                index={i}
                removeFilter={removeFilter}
              />
            );
          })}
          {/* {filterData.length > 0 ? (
            <div className="save-filter">Save Filter</div>
          ) : (
            ""
          )} */}
        </Row>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="p-0">
                  <CarListTable
                    inventoryData={inventoryData}
                    onChangePage={onChangePage}
                    paginationPerPage={rowsPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    setShowApiLoader={setLoader}
                    globalCityField={globalCityField}
                    fetchCarData={() =>
                      fetchCarData({isSearchFilterPage: pagination})
                    }
                    pagination={pagination}
                    setPageNumber={setPageNumber}
                    pageNumber={
                      location.state?.pageNumber
                        ? location.state.pageNumber + 1
                        : 1
                    }
                    loader={loader}
                    filterData={filterData}
                    searchData={searchData}
                  />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CarListing;
